import axios from 'axios';
import Cookies from 'js-cookie';
import dotenv from 'dotenv';
import { stringifyLanguages, getLanguageCookie } from '../utilities/language';
// import { IsPlannerToolAppType } from '../utilities/config';
// eslint-disable-next-line import/named
import { getClientId } from '../utilities/uuid_util';
import { writeWebToken } from '../utilities/initAdapter';

dotenv.config();

export const FUNLIDAY_HOST_URL = process.env.REACT_APP_FUNLIDAY_API_HOST_URL;
export const JOURNAL_HOST_URL = process.env.REACT_APP_JOURNAL_API_HOST_URL;
// JOURNAL_HOST_URL CDN version
export const CDN_JOURNAL_HOST_URL = process.env.REACT_APP_CDN_JOURNAL_HOST_URL;
export const POI_BANK_HOST_URL = process.env.REACT_APP_POI_BANK_HOST_URL;
export const EC_HOST_URL = process.env.REACT_APP_EC_HOST_URL;
export const SECRET_FOR_INIT =
  process.env.REACT_APP_NODE_ENV === 'production'
    ? 'funlidayinitsecretIdXX0X'
    : 'funlidaysecretidforinit';

export const X_FUNLIDAY_OS = '2';
export const X_FUNLIDAY_VERSION = '1.0.0';

export const X_FUNLIDAY_HEADERS = {
  'Content-Type': 'application/json',
  'x-funliday-os': X_FUNLIDAY_OS,
  'x-funliday-version': X_FUNLIDAY_VERSION,
  'x-funliday-deviceid': '',
  'x-funliday-language': '',
  'x-funliday-langapp': ''
};

/** getCookieToken
 * @description 檢查 cookie 是否有 webToken，目前只有 bot 爬蟲才會從 cookie 拿 token
 * @returns {object}
 */
const getCookieToken = () => {
  const WebTokenForBot = Cookies.get('webToken');
  if (WebTokenForBot) {
    const { webToken } = JSON.parse(WebTokenForBot);

    return {
      isBot: true,
      token: webToken
    };
  }
  return {
    isBot: false,
    token: null
  };
};

export const getHeaders = (noToken = false) => {
  const cookieData = getCookieToken();
  const language = getLanguageCookie();
  const clientId = getClientId();
  const location = localStorage.getItem('location');
  // const area = localStorage.getItem('area');
  // const isPlannerToolType = IsPlannerToolAppType(); // IsPlannerToolTypeAppType() 目前的遺物是吃 .env 參數
  X_FUNLIDAY_HEADERS['x-funliday-language'] = language.replace('-', '_'); // 前端自己判斷是 zh-tw、zh-ch 但後端 DB 有轉的限制需要 zh_tw、zh_ch
  // language for backend, x-funliday-language will be deprecated
  X_FUNLIDAY_HEADERS['x-funliday-langapp'] = language.replace('-', '_');
  X_FUNLIDAY_HEADERS['x-funliday-langos'] = stringifyLanguages();

  // if (isPlannerToolType && window.funlidayLib) {
  if (window.funlidayLib) {
    const { origin, apiKey, deviceId } = window.funlidayLib;
    X_FUNLIDAY_HEADERS['x-funliday-deviceid'] = deviceId;
    if (origin) {
      X_FUNLIDAY_HEADERS['x-funliday-sdkorigin'] = origin;
    }

    if (origin && apiKey) {
      X_FUNLIDAY_HEADERS['x-funliday-sdkorigin'] = origin;
      X_FUNLIDAY_HEADERS['x-funliday-sdkapikey'] = apiKey;
    }
  } else X_FUNLIDAY_HEADERS['x-funliday-deviceid'] = clientId;

  const headers = { ...X_FUNLIDAY_HEADERS };
  if (location) headers['x-funliday-location'] = location;
  // if (area) headers['x-funliday-area'] = area;
  if (noToken) return headers;

  if (cookieData.isBot) {
    headers.Authorization = `Bearer ${cookieData.token}`;
    return headers;
  }

  const member = localStorage.getItem('member');
  const accessToken = localStorage.getItem('accessToken');
  const webToken = JSON.parse(localStorage.getItem('webToken'));
  if (member && accessToken) {
    const { _id: memberId } = JSON.parse(member);
    const { token } = JSON.parse(accessToken);
    headers.Authorization = `Bearer ${memberId}_${token}`;
  } else if (webToken) {
    headers.Authorization = `Bearer ${webToken.token}`;
  }
  return headers;
};

const getPoiBankHeaders = () => {
  const language = getLanguageCookie();
  const clientId = getClientId();
  const fDeviceId = window.funlidayLib?.deviceId;
  const location = localStorage.getItem('location');
  // const area = localStorage.getItem('area');
  const headers = {
    ...X_FUNLIDAY_HEADERS,
    'x-funliday-language': language.replace('-', '_'),
    'x-funliday-langapp': language.replace('-', '_'),
    'x-funliday-deviceid': fDeviceId ?? clientId,
    'x-funliday-langos': stringifyLanguages()
  };
  if (location) headers['x-funliday-location'] = location;
  // if (area) headers['x-funliday-area'] = area;
  return headers;
};

const checkWebToken = axiosConfig => {
  const accessToken = localStorage.getItem('accessToken');
  // 沒有 accessToken => 非登入狀態， 在 initAdapter 檢查 webToken 是否過期，過期就重新取得
  if (!accessToken) {
    writeWebToken();
  }
  return axiosConfig;
};

const getRequest = baseURL =>
  axios.create({
    baseURL
  });

export const funlidayRequest = getRequest(FUNLIDAY_HOST_URL);
export const journalRequest = getRequest(JOURNAL_HOST_URL);
export const cdnJournalRequest = getRequest(CDN_JOURNAL_HOST_URL);
export const poiBankRequest = getRequest(POI_BANK_HOST_URL);
export const ecRequest = getRequest(EC_HOST_URL);

funlidayRequest.interceptors.request.use(config => {
  const newConfig = { ...config };
  newConfig.headers = { ...getHeaders(), ...newConfig.headers };
  return checkWebToken(newConfig);
});

journalRequest.interceptors.request.use(config => {
  const newConfig = { ...config };
  newConfig.headers = { ...getHeaders(), ...newConfig.headers };
  return checkWebToken(newConfig);
});

ecRequest.interceptors.request.use(config => {
  const newConfig = { ...config };
  newConfig.headers = { ...getHeaders(), ...newConfig.headers };
  return checkWebToken(newConfig);
});

// cdnJournalRequest don't use any token
cdnJournalRequest.interceptors.request.use(config => {
  const newConfig = { ...config };
  newConfig.headers = { ...getHeaders(true), ...newConfig.headers };
  return newConfig;
});

// poiBank use poiToken, don't check webToken
poiBankRequest.interceptors.request.use(config => {
  const newConfig = { ...config };
  newConfig.headers = { ...getPoiBankHeaders(), ...newConfig.headers };
  return newConfig;
});
